var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr"},[_c('img',{attrs:{"src":_vm.createQr(_vm.data, _vm.number, _vm.level),"alt":"qr"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }